import { getContext } from '@fiverr-private/fiverr_context';
import { translate } from '@fiverr-private/i18n-react';
import { getShortLanguageCode } from '@fiverr-private/localization';

const getSpeakerInfo = (shortLocale: string) => {
    const speakerMap: Record<string, { key: string; count: string }> = {
        de: { key: 'speakersDe', count: '180,000' },
        fr: { key: 'speakersFr', count: '200,000' },
        es: { key: 'speakersEs', count: '250,000' },
        it: { key: 'speakersIt', count: '40,000' },
        nl: { key: 'speakersNl', count: '25,000' },
        pt: { key: 'speakersPt', count: '30,000' },
    };

    return speakerMap[shortLocale] || speakerMap.de; // Default to German if locale not found
};

export const getCoreFeatures = () => {
    const { locale } = getContext();
    const shortLocale = getShortLanguageCode(locale);
    const speakerInfo = getSpeakerInfo(shortLocale);

    return [
        {
            title: translate(`logged_out_homepage.de.core_features.${speakerInfo.key}`, {
                params: { amount: speakerInfo.count },
            }),
            src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/f67fafafeeb08f54559584f424fca27b-1755099085099/speakersLOHP.png',
        },
        {
            title: translate('logged_out_homepage.de.core_features.support'),
            src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/f67fafafeeb08f54559584f424fca27b-1755099085116/supportLOHP.png',
        },
        {
            title: translate('logged_out_homepage.de.core_features.secured_payment'),
            src: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/f67fafafeeb08f54559584f424fca27b-1755099085100/secureLOHP.png',
        },
    ];
};
